import {
  SET_PENDING_DEAL_OFFER_ACTION,
  CLEAR_PENDING_DEAL_OFFER_ACTION,
  SET_APPLIED_DEAL_ROW_UPDATE,
  CLEAR_APPLIED_DEAL_ROW_UPDATE,
} from './mutation-types';

export default {
  [SET_PENDING_DEAL_OFFER_ACTION](state, payload) {
    state.pendingDealOfferAction = payload;
  },
  [CLEAR_PENDING_DEAL_OFFER_ACTION](state) {
    state.pendingDealOfferAction = null;
  },
  [SET_APPLIED_DEAL_ROW_UPDATE](state, payload) {
    state.appliedDealRowUpdate = payload;
  },
  [CLEAR_APPLIED_DEAL_ROW_UPDATE](state) {
    state.appliedDealRowUpdate = null;
  },
};
